import moment from "moment"
import React from "react"

const RepairDeclinedInfo = ({ entry, myUser }) => {
  const IsUserRepairLabor = () => myUser?.company?.id == entry?.repairLaborID
  const isUserSeller = () => myUser?.company?.id == entry?.sellerCompanyID
  const isUserRequestor = () => myUser?.company?.id == entry?.requestorCompanyID

  return (
    <>
      {entry?.dateDeclined && (
        <li className="event-list">
          <div className="event-timeline-dot ">
            <i className="bx bx-right-arrow-circle font-size-18"></i>
          </div>
          <div className="d-flex">
            <div className="flex-shrink-0 me-3">
              <h5 className="font-size-14">
                {moment(entry.dateDeclined).format("DD.MM.YYYY")}{" "}
                <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
              </h5>
            </div>
            <div className="flex-grow-1">
              <div>Report Declined</div>
            </div>
          </div>
          <div className="mt-2">
            {
              <p className="mb-0" style={{ cursor: "pointer" }}>
                The Repair report is rejected by the requestor.
                <br />
                For further discussions regarding the shipment of the goods,
                please use the chat on the right side.
              </p>
            }
          </div>
        </li>
      )}
    </>
  )
}

export default RepairDeclinedInfo
